import {
  selectUserForTempRightsRDUsers,
  UserReferenceDataType,
} from '@app/store/settings/user-rights';
import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useState } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchUserReferenceDataAction } from '@app/store/settings/user-rights';
import { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';

interface UserPermanentSelectPropsType {
  label: string;
  placeholder: string;
  value: UserReferenceDataType | null;
  onChange: (value: UserReferenceDataType | null) => void;
  selectUser: UserReferenceDataType | null;
}

export const UserPermanentSelect = ({
  label,
  placeholder,
  value,
  onChange,
  selectUser,
}: UserPermanentSelectPropsType) => {
  const dispatch = useDispatch();

  //===== DATA FROM STATE =====

  const options = useSelector(selectUserForTempRightsRDUsers);

  //===== CREATE LOCAL STATE =====

  const [isLoading, setIsLoading] = useState(options.length === 0);

  //===== DATA WATCHER =====

  useEffect(() => {
    dispatch(fetchUserReferenceDataAction({}));
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) setIsLoading(options.length === 0); // todo need fix
  }, [isLoading, options]);

  //===== HANDLERS =====

  const handlerOpen = useCallback(() => {
    setIsLoading(true);
    dispatch(fetchUserReferenceDataAction({}));
  }, [dispatch]);

  return (
    <Grid container item spacing={2}>
      <Grid item container alignItems="center" xs={6}>
        {label}:
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          value={value}
          options={
            selectUser
              ? options.filter((option) => option.id !== selectUser.id)
              : options
          }
          getOptionSelected={(i, value) => i.id === value.id}
          getOptionLabel={(i) => i.firstName + ' ' + i.lastName}
          onOpen={() => isLoading && handlerOpen}
          loading={isLoading}
          onChange={(e, value) => onChange(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={placeholder}
              required
              variant="outlined"
            />
          )}
          fullWidth={true}
          size="small"
        />
      </Grid>
    </Grid>
  );
};
